// Copyright © 2011-2025 David Caldwell <david@porkrind.org>

var dom=require('./dom'), doc=dom.doc, on_load=dom.on_load;
var hs = require('./highscore'), highscore_query=hs.highscore_query, render_highscores=hs.render_highscores,
                               short_date=hs.short_date, elapsed=hs.elapsed;
var Login = require('./login');
var ajax = require('./ajax'), loadJSON=ajax.loadJSON, postJSON=ajax.postJSON, makeurl=ajax.makeurl;
var lib = require('./lib'), map=lib.map, map_obj=lib.map_obj, merge=lib.merge;
var prnt = require('./print'), printf=prnt.printf, sprintf=prnt.sprintf;
var render_errors = require('./errors');
var color = require('./color'), hsl_from_hex=color.hsl_from_hex, css_from_hsl=color.css_from_hsl, add_hsl=color.add_hsl;

var path_user = decodeURIComponent(document.location.pathname).replace(/^\/@/, "");
var user;

var title = map_obj((key, obj) => { obj[obj[key].name] = obj[key]; delete obj[key]; return obj }, window.titles /* see user.tt2 */);

function update_statistics() {
    var div = doc.id("statistics");
    doc.clear(div).appendChild(doc(['p', "Loading statistics..."]));
    loadJSON(makeurl('user', 'stats', user), function(data, error, status) {
        if (error)
            doc.clear(div).appendChild(doc(["p", "Error loading statistics!! Server said: "+error]));
        else
            render_statistics(div, data);
    });
}

function vague_time(seconds) {
    if (seconds < 60)   return `${          seconds       } Seconds`;
    if (seconds < 3600) return `${Math.round(seconds/60)  } Minutes`;
    else                return `${Math.round(seconds/3600)} Hours`;
}

function render_statistics(div, data) {
    var won_lost_by_title = {};
    for (let t in data.won_by_title)
        won_lost_by_title[t] = merge(won_lost_by_title[t] || {lost:0}, { won:  data.won_by_title[t] });
    for (let t in data.lost_by_title)
        won_lost_by_title[t] = merge(won_lost_by_title[t] || {won: 0}, { lost: data.lost_by_title[t] });
    var max_played = Math.max.apply(this, map((data, title) => data.won + data.lost, won_lost_by_title));
    var max_seconds = Math.max.apply(this, map((seconds, title) => seconds, data.seconds_by_title));

    var show = (id) => {
        for (let div of ['time-played', 'win-percentage', 'games-played'])
            doc.id(div).style.display = id == div ? 'block' : 'none';
        return false;
    }

    var bar_graph_table = (id, rows) =>
             ['table', { id: id, className: 'bar-graph-table', style: { display: 'none' } },
              ['tbody',
               map(stat => ['tr',
                            ['td', { className: 'long-name' }, title[stat.title].long_name],
                            ['td',  { className: 'bar-cell' },
                             ['div', { className: 'bar', style: { background: `#${title[stat.title].stats_color}`,
                                                                  right: (1-stat.bar)*100 + '%',
                                                                  borderRight: stat.bar < .01 ? 'none' : `1px solid ${css_from_hsl(add_hsl(hsl_from_hex(title[stat.title].stats_color), [0,0,30]))}` } }],
                             ['div', { className: 'value' }, stat.value]]],
                   rows.sort((a,b) => b.bar - a.bar))
              ]];

    doc.clear(div).appendChild(
        doc(['div',
             ['div', { id: "control_panel" },
              ['a', { className: 'button', href:'#', onclick:(e)=>show('time-played') }, "Time Played"],
              ['a', { className: 'button', href:'#', onclick:(e)=>show('games-played') }, "Games Played"],
              ['a', { className: 'button', href:'#', onclick:(e)=>show('win-percentage') }, "Win Percentages"]],
             bar_graph_table('time-played', map((seconds, title) => ({ title, bar: seconds/max_seconds,         value: vague_time(seconds) }), data.seconds_by_title)),
             bar_graph_table('games-played', map((wl,     title) => ({ title, bar: (wl.won+wl.lost)/max_played, value: `${wl.won+wl.lost} Games` }), won_lost_by_title)),
             bar_graph_table('win-percentage', map((wl,   title) => ({ title, bar: wl.won/(wl.won+wl.lost),     value: `${Math.round(wl.won/(wl.won+wl.lost)*100)}% Won` }), won_lost_by_title))
            ]));
    show('time-played');
}

function update_games() {
    doc.id("refresh").value = "Loading history...";
    doc.id("refresh").disabled = true;
	highscore_query(makeurl('query','last','100',user),
                    function(scores, place, error, status) {
	    render_highscores(doc.id("games").firstChild, scores);
    	doc.id("refresh").value = "Refresh";
    	doc.id("refresh").disabled = false;
    });
}

function browser_from_ua(ua) {
    var m;
    if ((m=ua.match(/(MSIE \d+\\.\d+)/))    ||
        (m=ua.match(/(Chrome\/[\d.]+)/))    ||
        (m=ua.match(/(Safari\/[\d.]+)/))    ||
        (m=ua.match(/(Firefox\/[\d.]+)/))   ||
        (m=ua.match(/(SeaMonkey\/[\d.]+)/)) ||
        (m=ua.match(/(Opera\/[\d.]+)/))     ||
        (m=ua.match(/(WebKit)/))            ||
        (m=ua.match(/(Gecko)/)))
        return m[1];

    return '???';
}

function os_from_ua(ua) {
    if (ua.match(/(Win(dows )?98)/))     return 'Windows 98';
    if (ua.match(/(Windows NT 4.0)/))    return 'Windows NT 4.0';
    if (ua.match(/(Windows NT 5.0)/))    return 'Windows 2000';
    if (ua.match(/(Windows NT 5.[12])/)) return 'Windows XP';
    if (ua.match(/(Windows NT 6.0)/))    return 'Windows Vista';
    if (ua.match(/(Windows NT 6.1)/))    return 'Windows 7';
    var m;
    if (m = ua.match(/(Mac OS X( [\d._]+)?)/)) return m[1].replace('_','.');
    if (m = ua.match(/(Linux)/)) return m[1];
    return '???';
}

function render_history(div, history) {
    var render_login = function (login) {
        //printf("Rendering login: %j\n", login);
        return ['tr',
                ['td', short_date(login.date)],
                ['td', login.action ],
                ['td', login.detail == undefined ? '' :
                       login.detail?.by          ? `by ${login.detail?.by}` :
                       login.detail?.from        ? `${login.detail.from} -> ${login.detail.to}`
                                                 : JSON.stringify(login.detail) ],
                login.client_ip    ? ['td', login.client_ip    ] : {},
                login.user_agent   ? ['td', browser_from_ua(login.user_agent) + " on " + os_from_ua(login.user_agent)   ] : {},
                login.referer      ? ['td', login.referer      ] : {},
                login.virtual_host ? ['td', login.virtual_host ] : {},
                login.session      ? ['td', login.session      ] : {},
               ];
    };
    var render_play = function (play) {
        //printf("Rendering play: %j\n", play);
        return ['tr',
                ['td', short_date(play.date)],
                ['td', "played"],
                ['td', { colSpan: 5 }, sprintf("%-15s seed: %10d score: %5d moves: %4d elapsed: %s", play.name, play.seed, play.score, play.moves, elapsed(play.elapsed)) ],
               ];
    };

    doc.clear(div).appendChild(doc(['table',
                               ['tbody',
                                map(function(r) {
                                    if (r.login) return render_login(r.login);
                                    if (r.play)  return render_play(r.play);
                                    if (!r.login && ! r.play) printf("Bad row! %j\n", r);
                                }, history)]]));

    if (history.length == 0)
        doc.clear(div).appendChild(doc("Nothing happened in the past "+doc.id("range")[doc.id("range").selectedIndex].firstChild.textContent));
}

function update_admin() {
     doc.id('admin').classList.set(Login.is_admin, 'admin');
     return Login.is_admin;
}

function update_history() {
    var div = doc.id('history');
    if (!update_admin())
        return;
    doc.clear(div).appendChild(doc(['p', "Loading history..."]));
    loadJSON(makeurl('user', 'history', user, doc.id("range").value), function(data, error, status) {
        if (error)
            div.appendChild(doc(["p", "Error loading history!! Server said: "+error]));
        else
            render_history(div, data.history);
    });
}
doc.id("range").onchange=update_history;

function update_title() {
    var title_text = doc.id("title-head").firstChild.textContent.replace(/^User[^-]+/, "User: "+ user + " ");
    doc.clear(doc.id("title")     ).appendChild(doc.text(user));
    doc.clear(doc.id("title-head")).appendChild(doc.text(title_text));
}

function update_errors() {
    var div = doc.id("errors");
    if (!update_admin())
        return;
    doc.clear(div).appendChild(doc(['p', "Please wait..."]));
    doc.clear(div);
    loadJSON(makeurl('error', 'for_user', user), function(data, error, status) {
        if (error)
            div.appendChild(doc(["p", "Error loading history!! Server said: "+error]));
        else
            render_errors(div, data.error);
    });
}

function update_banned() {
    if (!update_admin())
        return;
    var div=doc.id("banned");
    loadJSON(makeurl('user', 'banned', user), (data, error, status) => {
        if (error)
            doc.clear(div).appendChild(doc.text("Error: "+error));
        else {
            doc.clear(div).appendChild(doc.text(data.banned));
            div.classList.set(data.banned, 'banned');
        }
    });
    let banhammer = doc.id("banhammer");
    banhammer.onclick = (e) => {
        postJSON(makeurl('user', 'change', 'banned', { user: user, ban: div.classList.contains('banned') ? "no" : "yes" }), {}, (data, error, status) => {
            if (error)
                printf("Error %sbanning %s: %s\n", div.classList.contains('banned') ? "un" : "", user, error);
            update_banned();
        });
    };
}

function update_page() {
    user = path_user ? path_user : Login.is_logged_in() ? Login.user : "anonymous";
    update_title();
    update_statistics();
    update_games();
    update_banned();
    update_history();
    update_errors();
}
on_load(update_page);
if (Login) Login.on_login(update_page);
doc.id('refresh').onclick = function() { update_games() };
// Copyright © 2011-2025 David Caldwell <david@porkrind.org>

var dom=require('./dom'), doc=dom.doc, on_load=dom.on_load;
var hs = require('./highscore'), highscore_query=hs.highscore_query, render_highscores=hs.render_highscores,
                               short_date=hs.short_date, elapsed=hs.elapsed;
var Login = require('./login');
var ajax = require('./ajax'), loadJSON=ajax.loadJSON, postJSON=ajax.postJSON, makeurl=ajax.makeurl;
var lib = require('./lib'), map=lib.map, map_obj=lib.map_obj, merge=lib.merge;
var prnt = require('./print'), printf=prnt.printf, sprintf=prnt.sprintf;
var render_errors = require('./errors');
var color = require('./color'), hsl_from_hex=color.hsl_from_hex, css_from_hsl=color.css_from_hsl, add_hsl=color.add_hsl;

var path_user = decodeURIComponent(document.location.pathname).replace(/^\/@/, "");
var user;

var title = map_obj((key, obj) => { obj[obj[key].name] = obj[key]; delete obj[key]; return obj }, window.titles /* see user.tt2 */);

function update_statistics() {
    var div = doc.id("statistics");
    doc.clear(div).appendChild(doc(['p', "Loading statistics..."]));
    loadJSON(makeurl('user', 'stats', user), function(data, error, status) {
        if (error)
            doc.clear(div).appendChild(doc(["p", "Error loading statistics!! Server said: "+error]));
        else
            render_statistics(div, data);
    });
}

function vague_time(seconds) {
    if (seconds < 60)   return `${          seconds       } Seconds`;
    if (seconds < 3600) return `${Math.round(seconds/60)  } Minutes`;
    else                return `${Math.round(seconds/3600)} Hours`;
}

function render_statistics(div, data) {
    var won_lost_by_title = {};
    for (let t in data.won_by_title)
        won_lost_by_title[t] = merge(won_lost_by_title[t] || {lost:0}, { won:  data.won_by_title[t] });
    for (let t in data.lost_by_title)
        won_lost_by_title[t] = merge(won_lost_by_title[t] || {won: 0}, { lost: data.lost_by_title[t] });
    var max_played = Math.max.apply(this, map((data, title) => data.won + data.lost, won_lost_by_title));
    var max_seconds = Math.max.apply(this, map((seconds, title) => seconds, data.seconds_by_title));

    var show = (id) => {
        for (let div of ['time-played', 'win-percentage', 'games-played'])
            doc.id(div).style.display = id == div ? 'block' : 'none';
        return false;
    }

    var bar_graph_table = (id, rows) =>
             ['table', { id: id, className: 'bar-graph-table', style: { display: 'none' } },
              ['tbody',
               map(stat => ['tr',
                            ['td', { className: 'long-name' }, title[stat.title].long_name],
                            ['td',  { className: 'bar-cell' },
                             ['div', { className: 'bar', style: { background: `#${title[stat.title].stats_color}`,
                                                                  right: (1-stat.bar)*100 + '%',
                                                                  borderRight: stat.bar < .01 ? 'none' : `1px solid ${css_from_hsl(add_hsl(hsl_from_hex(title[stat.title].stats_color), [0,0,30]))}` } }],
                             ['div', { className: 'value' }, stat.value]]],
                   rows.sort((a,b) => b.bar - a.bar))
              ]];

    doc.clear(div).appendChild(
        doc(['div',
             ['div', { id: "control_panel" },
              ['a', { className: 'button', href:'#', onclick:(e)=>show('time-played') }, "Time Played"],
              ['a', { className: 'button', href:'#', onclick:(e)=>show('games-played') }, "Games Played"],
              ['a', { className: 'button', href:'#', onclick:(e)=>show('win-percentage') }, "Win Percentages"]],
             bar_graph_table('time-played', map((seconds, title) => ({ title, bar: seconds/max_seconds,         value: vague_time(seconds) }), data.seconds_by_title)),
             bar_graph_table('games-played', map((wl,     title) => ({ title, bar: (wl.won+wl.lost)/max_played, value: `${wl.won+wl.lost} Games` }), won_lost_by_title)),
             bar_graph_table('win-percentage', map((wl,   title) => ({ title, bar: wl.won/(wl.won+wl.lost),     value: `${Math.round(wl.won/(wl.won+wl.lost)*100)}% Won` }), won_lost_by_title))
            ]));
    show('time-played');
}

function update_games() {
    doc.id("refresh").value = "Loading history...";
    doc.id("refresh").disabled = true;
	highscore_query(makeurl('query','last','100',user),
                    function(scores, place, error, status) {
	    render_highscores(doc.id("games").firstChild, scores);
    	doc.id("refresh").value = "Refresh";
    	doc.id("refresh").disabled = false;
    });
}

function browser_from_ua(ua) {
    var m;
    if ((m=ua.match(/(MSIE \d+\\.\d+)/))    ||
        (m=ua.match(/(Chrome\/[\d.]+)/))    ||
        (m=ua.match(/(Safari\/[\d.]+)/))    ||
        (m=ua.match(/(Firefox\/[\d.]+)/))   ||
        (m=ua.match(/(SeaMonkey\/[\d.]+)/)) ||
        (m=ua.match(/(Opera\/[\d.]+)/))     ||
        (m=ua.match(/(WebKit)/))            ||
        (m=ua.match(/(Gecko)/)))
        return m[1];

    return '???';
}

function os_from_ua(ua) {
    if (ua.match(/(Win(dows )?98)/))     return 'Windows 98';
    if (ua.match(/(Windows NT 4.0)/))    return 'Windows NT 4.0';
    if (ua.match(/(Windows NT 5.0)/))    return 'Windows 2000';
    if (ua.match(/(Windows NT 5.[12])/)) return 'Windows XP';
    if (ua.match(/(Windows NT 6.0)/))    return 'Windows Vista';
    if (ua.match(/(Windows NT 6.1)/))    return 'Windows 7';
    var m;
    if (m = ua.match(/(Mac OS X( [\d._]+)?)/)) return m[1].replace('_','.');
    if (m = ua.match(/(Linux)/)) return m[1];
    return '???';
}

function render_history(div, history) {
    var render_login = function (login) {
        //printf("Rendering login: %j\n", login);
        return ['tr',
                ['td', short_date(login.date)],
                ['td', login.action ],
                ['td', login.detail == undefined ? '' :
                       login.detail?.by          ? `by ${login.detail?.by}` :
                       login.detail?.from        ? `${login.detail.from} -> ${login.detail.to}`
                                                 : JSON.stringify(login.detail) ],
                login.client_ip    ? ['td', login.client_ip    ] : {},
                login.user_agent   ? ['td', browser_from_ua(login.user_agent) + " on " + os_from_ua(login.user_agent)   ] : {},
                login.referer      ? ['td', login.referer      ] : {},
                login.virtual_host ? ['td', login.virtual_host ] : {},
                login.session      ? ['td', login.session      ] : {},
               ];
    };
    var render_play = function (play) {
        //printf("Rendering play: %j\n", play);
        return ['tr',
                ['td', short_date(play.date)],
                ['td', "played"],
                ['td', { colSpan: 5 }, sprintf("%-15s seed: %10d score: %5d moves: %4d elapsed: %s", play.name, play.seed, play.score, play.moves, elapsed(play.elapsed)) ],
               ];
    };

    doc.clear(div).appendChild(doc(['table',
                               ['tbody',
                                map(function(r) {
                                    if (r.login) return render_login(r.login);
                                    if (r.play)  return render_play(r.play);
                                    if (!r.login && ! r.play) printf("Bad row! %j\n", r);
                                }, history)]]));

    if (history.length == 0)
        doc.clear(div).appendChild(doc("Nothing happened in the past "+doc.id("range")[doc.id("range").selectedIndex].firstChild.textContent));
}

function update_admin() {
     doc.id('admin').classList.set(Login.is_admin, 'admin');
     return Login.is_admin;
}

function update_history() {
    var div = doc.id('history');
    if (!update_admin())
        return;
    doc.clear(div).appendChild(doc(['p', "Loading history..."]));
    loadJSON(makeurl('user', 'history', user, doc.id("range").value), function(data, error, status) {
        if (error)
            div.appendChild(doc(["p", "Error loading history!! Server said: "+error]));
        else
            render_history(div, data.history);
    });
}
doc.id("range").onchange=update_history;

function update_title() {
    var title_text = doc.id("title-head").firstChild.textContent.replace(/^User[^-]+/, "User: "+ user + " ");
    doc.clear(doc.id("title")     ).appendChild(doc.text(user));
    doc.clear(doc.id("title-head")).appendChild(doc.text(title_text));
}

function update_errors() {
    var div = doc.id("errors");
    if (!update_admin())
        return;
    doc.clear(div).appendChild(doc(['p', "Please wait..."]));
    doc.clear(div);
    loadJSON(makeurl('error', 'for_user', user), function(data, error, status) {
        if (error)
            div.appendChild(doc(["p", "Error loading history!! Server said: "+error]));
        else
            render_errors(div, data.error);
    });
}

function update_banned() {
    if (!update_admin())
        return;
    var div=doc.id("banned");
    loadJSON(makeurl('user', 'banned', user), (data, error, status) => {
        if (error)
            doc.clear(div).appendChild(doc.text("Error: "+error));
        else {
            doc.clear(div).appendChild(doc.text(data.banned));
            div.classList.set(data.banned, 'banned');
        }
    });
    let banhammer = doc.id("banhammer");
    banhammer.onclick = (e) => {
        postJSON(makeurl('user', 'change', 'banned', { user: user, ban: div.classList.contains('banned') ? "no" : "yes" }), {}, (data, error, status) => {
            if (error)
                printf("Error %sbanning %s: %s\n", div.classList.contains('banned') ? "un" : "", user, error);
            update_banned();
        });
    };
}

function update_page() {
    user = path_user ? path_user : Login.is_logged_in() ? Login.user : "anonymous";
    update_title();
    update_statistics();
    update_games();
    update_banned();
    update_history();
    update_errors();
}
on_load(update_page);
if (Login) Login.on_login(update_page);
doc.id('refresh').onclick = function() { update_games() };
